export enum CardFileType {
  PrimaryScan = 'PrimaryScan',
  Scan = 'Scan',
}
